import {
  EXEBOOT_BROADBAND_PLAN_IDS,
  EXEBOOT_MOBILE_PLAN_IDS,
} from '@/constants/app.constants';
import type { UserService } from '@/services/apis/auth/auth.schemas';

/**
 * Check if a user has at least one of the new Exeboot NBN plans.
 * @param services - The services of the user
 * @returns True if the user has at least one of the new Exeboot plans, false otherwise
 */
export const hasAtLeastOneTheOnePlan = ({
  services,
}: {
  services: UserService;
}) => {
  return services.some(
    (service) =>
      service.serviceType === 'BROADBAND' &&
      EXEBOOT_BROADBAND_PLAN_IDS.includes(service.offer.id)
  );
};

/**
 * Check if a user is a legacy user.
 * It runs the check based on EXEBOOT_BROADBAND_PLAN_IDS and EXEBOOT_MOBILE_PLAN_IDS
 * @param services - The services of the user
 * @returns True if the user is a legacy user, false otherwise
 */
export const isLegacyUser = ({ services }: { services: UserService }) => {
  return services.some(
    (service) =>
      (service.serviceType === 'BROADBAND' &&
        !EXEBOOT_BROADBAND_PLAN_IDS.includes(service.offer.id)) ||
      (service.serviceType === 'MOBILE' &&
        !EXEBOOT_MOBILE_PLAN_IDS.includes(service.offer.id))
  );
};
